module.exports = __webpack_public_path__ + "img/five_zhTc.1987faee.png";